import { Reveal } from "./Reveal";
import { MessageCircleQuestion, ArrowRight } from "lucide-react";

const OBJECTIONS = [
  {
    doubt: "\u201CIt\u2019s probably just free blog tips dressed up as a PDF.\u201D",
    answer: "Listicles tell you WHAT (dark room, no caffeine). This is the HOW: the exact scripts, timings, and sequence — plus the 3AM Playbook and tracker you'll never find in a blog post.",
  },
  {
    doubt: "\u201CI've had insomnia for years. I'm probably the exception.\u201D",
    answer: "Chronic insomnia is exactly what behavioral sleep protocols were built for — this is the same technique family sleep clinics use, self-guided. And if you're truly the exception: one email, full refund, 30 nights to decide.",
  },
  {
    doubt: "\u201C$19.95\u2026 for a PDF?\u201D",
    answer: "One bad night costs more than that in coffee and lost focus. It's less than a single month of most sleep apps — and you own it forever, no subscription.",
  },
  {
    doubt: "\u201CI don't have time for a program.\u201D",
    answer: "Five minutes of reading and one exercise per night. If you have time to lie awake replaying Tuesday, you have time for this.",
  },
];

export function ObjectionCrusher({ onBuy }) {
  return (
    <section data-testid="objection-crusher" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:py-28">
      <Reveal className="text-center">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400/90">Still On The Fence?</p>
        <h2 className="font-display mx-auto mt-3 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Fair. Let's talk it out.
        </h2>
      </Reveal>
      <div className="mt-12 grid gap-4 md:grid-cols-2">
        {OBJECTIONS.map((o, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div data-testid={`objection-card-${i}`} className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#131a29] p-7">
              <p className="flex items-start gap-3 text-base font-semibold italic leading-relaxed text-slate-300">
                <MessageCircleQuestion className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
                {o.doubt}
              </p>
              <p className="mt-4 border-l-2 border-cyan-400/50 pl-4 text-sm leading-relaxed text-slate-400">{o.answer}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-10 text-center">
        <button
          data-testid="objection-cta-button"
          onClick={onBuy}
          className="group inline-flex items-center gap-2.5 rounded-full bg-cyan-400 px-8 py-4 text-base font-bold text-[#07090e] shadow-[0_0_40px_rgba(56,189,248,0.35)] transition-transform hover:scale-105 active:scale-95"
        >
          Start Night 1 Tonight — $19.95
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </button>
        <p className="mt-3 text-xs text-slate-500">Instant download · 30-night better-sleep guarantee</p>
      </Reveal>
    </section>
  );
}
